import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';

class RelateTitle extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    callAppHandle = (isJumpQQlink = false, isCallApp = true) => {
        const { content = {} } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710506194',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8967',
              };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid: content._id,
                kind: 'inter_fxy21',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    render() {
        const { content = {} } = this.props;
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'inter_fxy21',
        });

        return (
            <div className={styles.relateTitle}>
                <div className={styles.titleText}>热门视频推荐</div>
                <div className={styles.moreText} onClick={() => this.callAppHandle()}>
                    查看更多精彩内容
                    <span className={styles.moreIcon} />
                    {!content.isVideoShare && (
                        <WxLaunchApp
                            launchType="app"
                            launchAppClick={() => this.callAppHandle(false, false)}
                            schemeLink={schemeLink}
                            launchAppFail={() => this.callAppHandle(true, true)}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default errorBoundary(RelateTitle);
